import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.badgeClass)
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("i", {
      class: "bi bi-x-circle ms-2 close-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove')))
    })
  ], 2))
}